import axiosInstance from "../helpers/axiosInstance";

export default (setState) => {
  axiosInstance
    .get("account/balance")
    .then((res) => {
      res.data && setState(res.data);
    })
    .catch((err) => {});
};
